<template>
  <div class="contain-appointment-monthly" @click.prevent.stop="goToDetails">
    <div class="appoitment-inner">
      <div class="appoitment-inner-left">
        <span class="contain-meeting-start-time">{{
          appointment.startTime
        }}</span>
        <span class="contain-meeting-end-time">{{ appointment.endTime }}</span>
      </div>
      <div class="appoitment-inner-right">
        <span
          class="appoitment-client-name"
          :class="{ cancelled: appointment.cancelled }"
          v-html="appointment.title"
        ></span>
      </div>
    </div>
    <div class="appooitment-inner"></div>
    <div class="appooitment-inner"></div>
  </div>
</template>

<script>
export default {
  props: {
    appointment: Object
  },
  methods: {
    goToDetails() {
      this.$router.push("/appointment_detail/" + this.appointment.id);
    }
  }
};
</script>

<style scoped>
div.contain-appointment-monthly:last-of-type {
  margin-bottom: 90px !important;
}

.appoitment-inner-left span {
  font-size: 10px !important;
}

.cancelled {
  text-decoration: line-through;
}

.appoitment-inner-right span {
  width: calc(100% - 102px);
  position: absolute !important;
  top: 50%;
  transform: translateY(-50%);
  text-overflow: ellipsis !important;
  overflow: hidden !important;
  white-space: nowrap !important;
}
</style>
